// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"636":"3c6b4186","668":"90a825ae","717":"771602de","742":"081640d3","822":"7a0befae","879":"f80b1174","925":"6830ff49","973":"0cf82319"}[chunkId] + ".chunk.css";
};